export default __webpack_public_path__ + "img/eNsclNPi.ccc91d07.svg";